import { IAccountMappingMap } from '@modeso/types__aumico-lib-annualreport-be/dist/models/interfaces/IAccountMappingMap.interface';


export const germanySmeAccountPlan: IAccountMappingMap = {
    'entgeltlich erworbene Konzessionen, gewerbliche Schutzrechte und ähnliche Rechte und Werte sowie Lizenzen an solchen Rechten und Werten':
        [
            '110',
            '111',
            '112',
            '113',
            '114',
            '115',
            '116',
            '117',
            '118',
            '119',
            '120',
            '121',
            '122',
            '123',
            '124',
            '125',
            '126',
            '127',
            '128',
            '129',
            '130',
            '131',
            '132',
            '133',
            '134',
            '135',
            '136',
            '137',
            '138',
            '139',
            '140',
        ],
    'Geschäfts- oder Firmenwert': ['150', '151', '152', '153', '154', '155', '156', '157', '158', '159', '160'],
    'Grundstücke, grundstücksgleiche Rechte und Bauten einschließlich der Bauten auf fremden Grundstücken': [
        '200',
        '201',
        '202',
        '203',
        '204',
        '205',
        '206',
        '207',
        '208',
        '209',
        '210',
        '211',
        '212',
        '213',
        '214',
        '215',
        '216',
        '217',
        '218',
        '219',
        '220',
        '221',
        '222',
        '223',
        '224',
        '225',
        '226',
        '227',
        '228',
        '229',
        '230',
        '231',
        '232',
        '233',
        '234',
        '235',
        '236',
        '237',
        '238',
        '239',
        '240',
        '241',
        '242',
        '243',
        '244',
        '245',
        '246',
        '247',
        '248',
        '249',
        '250',
        '251',
        '252',
        '253',
        '254',
        '255',
        '256',
        '257',
        '258',
        '259',
        '260',
        '261',
        '262',
        '263',
        '264',
        '265',
        '266',
        '267',
        '268',
        '269',
        '270',
        '271',
        '272',
        '273',
        '274',
        '275',
        '276',
        '277',
        '278',
        '279',
        '280',
        '281',
        '282',
        '283',
        '284',
        '285',
        '286',
        '287',
        '288',
        '289',
        '290',
        '291',
        '292',
        '293',
        '294',
        '295',
        '296',
        '297',
        '298',
        '299',
        '300',
        '301',
        '302',
        '303',
        '304',
        '305',
        '306',
        '307',
        '308',
        '309',
        '310',
        '311',
        '312',
        '313',
        '314',
        '315',
        '316',
        '317',
        '318',
        '319',
        '320',
        '321',
        '322',
        '323',
        '324',
        '325',
        '326',
        '327',
        '328',
        '329',
        '330',
        '331',
        '332',
        '333',
        '334',
        '335',
        '336',
        '337',
        '338',
        '339',
        '340',
        '341',
        '342',
        '343',
        '344',
        '345',
        '346',
        '347',
        '348',
        '349',
        '350',
        '351',
        '352',
        '353',
        '354',
        '355',
        '356',
        '357',
        '358',
        '359',
        '360',
        '361',
        '362',
        '363',
        '364',
        '365',
        '366',
        '367',
        '368',
        '369',
        '370',
        '371',
        '372',
        '373',
        '374',
        '375',
        '376',
        '377',
        '378',
        '379',
        '380',
        '381',
        '382',
        '383',
        '384',
        '385',
        '386',
        '387',
        '388',
        '389',
        '390',
        '391',
        '392',
        '393',
        '394',
        '395',
        '396',
        '397',
        '398',
        '399',
    ],
    'technische Anlagen und Maschinen': [
        '400',
        '401',
        '402',
        '403',
        '404',
        '405',
        '406',
        '407',
        '408',
        '409',
        '410',
        '411',
        '412',
        '413',
        '414',
        '415',
        '416',
        '417',
        '418',
        '419',
        '420',
        '421',
        '422',
        '423',
        '424',
        '425',
        '426',
        '427',
        '428',
        '429',
        '430',
        '431',
        '432',
        '433',
        '434',
        '435',
        '436',
        '437',
        '438',
        '439',
        '440',
        '441',
        '442',
        '443',
        '444',
        '445',
        '446',
        '447',
        '448',
        '449',
        '450',
        '451',
        '452',
        '453',
        '454',
        '455',
        '456',
        '457',
        '458',
        '459',
        '460',
        '461',
        '462',
        '463',
        '464',
        '465',
        '466',
        '467',
        '468',
        '469',
        '470',
        '471',
        '472',
        '473',
        '474',
        '475',
        '476',
        '477',
        '478',
        '479',
        '480',
        '481',
        '482',
        '483',
        '484',
        '485',
        '486',
        '487',
        '488',
        '489',
        '490',
        '491',
        '492',
        '493',
        '494',
        '495',
        '496',
        '497',
        '498',
        '499',
    ],
    'andere Anlagen, Betriebs- und Geschäftsausstattung': [
        '500',
        '501',
        '502',
        '503',
        '504',
        '505',
        '506',
        '507',
        '508',
        '509',
        '510',
        '511',
        '512',
        '513',
        '514',
        '515',
        '516',
        '517',
        '518',
        '519',
        '520',
        '521',
        '522',
        '523',
        '524',
        '525',
        '526',
        '527',
        '528',
        '529',
        '530',
        '531',
        '532',
        '533',
        '534',
        '535',
        '536',
        '537',
        '538',
        '539',
        '540',
        '541',
        '542',
        '543',
        '544',
        '545',
        '546',
        '547',
        '548',
        '549',
        '550',
        '551',
        '552',
        '553',
        '554',
        '555',
        '556',
        '557',
        '558',
        '559',
        '560',
        '561',
        '562',
        '563',
        '564',
        '565',
        '566',
        '567',
        '568',
        '569',
        '570',
        '571',
        '572',
        '573',
        '574',
        '575',
        '576',
        '577',
        '578',
        '579',
        '580',
        '581',
        '582',
        '583',
        '584',
        '585',
        '586',
        '587',
        '588',
        '589',
        '590',
        '591',
        '592',
        '593',
        '594',
        '595',
        '596',
        '597',
        '598',
        '599',
        '600',
        '601',
        '602',
        '603',
        '604',
        '605',
        '606',
        '607',
        '608',
        '609',
        '610',
        '611',
        '612',
        '613',
        '614',
        '615',
        '616',
        '617',
        '618',
        '619',
        '620',
        '621',
        '622',
        '623',
        '624',
        '625',
        '626',
        '627',
        '628',
        '629',
        '630',
        '631',
        '632',
        '633',
        '634',
        '635',
        '636',
        '637',
        '638',
        '639',
        '640',
        '641',
        '642',
        '643',
        '644',
        '645',
        '646',
        '647',
        '648',
        '649',
        '650',
        '651',
        '652',
        '653',
        '654',
        '655',
        '656',
        '657',
        '658',
        '659',
        '660',
        '661',
        '662',
        '663',
        '664',
        '665',
        '666',
        '667',
        '668',
        '669',
        '670',
        '671',
        '672',
        '673',
        '674',
        '675',
        '676',
        '677',
        '678',
        '679',
        '680',
        '681',
        '682',
        '683',
        '684',
        '685',
        '686',
        '687',
        '688',
        '689',
        '690',
    ],
    Beteiligungen: [
        '800',
        '801',
        '802',
        '803',
        '804',
        '805',
        '806',
        '807',
        '808',
        '809',
        '810',
        '811',
        '812',
        '813',
        '814',
        '815',
        '816',
        '817',
        '818',
        '819',
        '820',
        '821',
        '822',
        '823',
        '824',
        '825',
        '826',
        '827',
        '828',
        '829',
        '830',
        '831',
        '832',
        '833',
        '834',
        '835',
        '836',
        '837',
        '838',
        '839',
        '840',
        '841',
        '842',
        '843',
        '844',
        '845',
        '846',
        '847',
        '848',
        '849',
        '850',
        '851',
        '852',
        '853',
        '854',
        '855',
        '856',
        '857',
        '858',
        '859',
        '860',
        '861',
        '862',
        '863',
        '864',
        '865',
        '866',
        '867',
        '868',
        '869',
    ],
    'Wertpapiere des Anlagevermögens': [
        '900',
        '901',
        '902',
        '903',
        '904',
        '905',
        '906',
        '907',
        '908',
        '909',
        '910',
        '911',
        '912',
        '913',
        '914',
        '915',
        '916',
        '917',
        '918',
        '919',
        '920',
        '921',
        '922',
        '923',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
    ],
    'Roh-, Hilfs-und Betriebsstoffe': [
        '1000',
        '1001',
        '1002',
        '1003',
        '1004',
        '1005',
        '1006',
        '1007',
        '1008',
        '1009',
        '1010',
        '1011',
        '1012',
        '1013',
        '1014',
        '1015',
        '1016',
        '1017',
        '1018',
        '1019',
        '1020',
        '1021',
        '1022',
        '1023',
        '1024',
        '1025',
        '1026',
        '1027',
        '1028',
        '1029',
        '1030',
        '1031',
        '1032',
        '1033',
        '1034',
        '1035',
        '1036',
        '1037',
        '1038',
        '1039',
    ],
    'unfertige Erzeugnisse, unfertige Leistungen': [
        '1040',
        '1041',
        '1042',
        '1043',
        '1044',
        '1045',
        '1046',
        '1047',
        '1048',
        '1049',
        '1050',
        '1051',
        '1052',
        '1053',
        '1054',
        '1055',
        '1056',
        '1057',
        '1058',
        '1059',
        '1060',
        '1061',
        '1062',
        '1063',
        '1064',
        '1065',
        '1066',
        '1067',
        '1068',
        '1069',
        '1070',
        '1071',
        '1072',
        '1073',
        '1074',
        '1075',
        '1076',
        '1077',
        '1078',
        '1079',
        '1080',
        '1081',
        '1082',
        '1083',
        '1084',
        '1085',
        '1086',
        '1087',
        '1088',
        '1089',
        '1090',
    ],
    'Forderungen aus Lieferungen und Leistungen': [
        '1200',
        '1201',
        '1202',
        '1203',
        '1204',
        '1205',
        '1206',
        '1207',
        '1208',
        '1209',
        '1210',
        '1211',
        '1212',
        '1213',
        '1214',
        '1215',
        '1216',
        '1217',
        '1218',
        '1219',
        '1220',
        '1221',
        '1222',
        '1223',
        '1224',
        '1225',
        '1226',
        '1227',
        '1228',
        '1229',
        '1230',
        '1231',
        '1232',
        '1233',
        '1234',
        '1235',
        '1236',
        '1237',
        '1238',
        '1239',
        '1240',
        '1241',
        '1242',
        '1243',
        '1244',
        '1245',
        '1246',
        '1247',
        '1248',
        '1249',
        '1250',
        '1251',
        '1252',
        '1253',
        '1254',
        '1255',
        '1256',
        '1257',
        '1258',
        '1259',
        '1260',
        '1261',
        '1262',
        '1263',
        '1264',
        '1265',
        '1266',
        '1267',
        '1268',
        '1269',
        '1270',
        '1271',
        '1272',
        '1273',
        '1274',
        '1275',
        '1276',
        '1277',
        '1278',
        '1279',
        '1280',
        '1281',
        '1282',
        '1283',
        '1284',
        '1285',
        '1286',
        '1287',
        '1288',
        '1289',
        '1290',
        '1291',
        '1292',
        '1293',
        '1294',
        '1295',
        '1296',
        '1297',
        '1298',
        '1299',
    ],
    'sonstige Vermögensgegenstände': [
        '1300',
        '1301',
        '1302',
        '1303',
        '1304',
        '1305',
        '1306',
        '1307',
        '1308',
        '1309',
        '1310',
        '1311',
        '1312',
        '1313',
        '1314',
        '1315',
        '1316',
        '1317',
        '1318',
        '1319',
        '1320',
        '1321',
        '1322',
        '1323',
        '1324',
        '1325',
        '1326',
        '1327',
        '1328',
        '1329',
        '1330',
        '1331',
        '1332',
        '1333',
        '1334',
        '1335',
        '1336',
        '1337',
        '1338',
        '1339',
        '1340',
        '1341',
        '1342',
        '1343',
        '1344',
        '1345',
        '1346',
        '1347',
        '1348',
        '1349',
        '1350',
        '1351',
        '1352',
        '1353',
        '1354',
        '1355',
        '1356',
        '1357',
        '1358',
        '1359',
        '1360',
        '1361',
        '1362',
        '1363',
        '1364',
        '1365',
        '1366',
        '1367',
        '1368',
        '1369',
        '1370',
        '1371',
        '1372',
        '1373',
        '1374',
        '1375',
        '1376',
        '1377',
        '1378',
        '1379',
        '1380',
        '1381',
        '1382',
        '1383',
        '1384',
        '1385',
        '1386',
        '1387',
        '1388',
        '1389',
        '1390',
        '1391',
        '1392',
        '1393',
        '1394',
        '1395',
        '1396',
        '1397',
        '1398',
        '1399',
        '1400',
        '1401',
        '1402',
        '1403',
        '1404',
        '1405',
        '1406',
        '1407',
        '1408',
        '1409',
        '1410',
        '1411',
        '1412',
        '1413',
        '1414',
        '1415',
        '1416',
        '1417',
        '1418',
        '1419',
        '1420',
        '1421',
        '1422',
        '1423',
        '1424',
        '1425',
        '1426',
        '1427',
        '1428',
        '1429',
        '1430',
        '1431',
        '1432',
        '1433',
        '1434',
        '1435',
        '1436',
        '1437',
        '1438',
        '1439',
        '1440',
        '1441',
        '1442',
        '1443',
        '1444',
        '1445',
        '1446',
        '1447',
        '1448',
        '1449',
        '1450',
        '1451',
        '1452',
        '1453',
        '1454',
        '1455',
        '1456',
        '1457',
        '1458',
        '1459',
        '1460',
        '1461',
        '1462',
        '1463',
        '1464',
        '1465',
        '1466',
        '1467',
        '1468',
        '1469',
        '1470',
        '1471',
        '1472',
        '1473',
        '1474',
        '1475',
        '1476',
        '1477',
        '1478',
        '1479',
        '1480',
        '1481',
        '1482',
        '1483',
        '1484',
        '1485',
        '1486',
        '1487',
        '1488',
        '1489',
        '1490',
        '1491',
        '1492',
        '1493',
        '1494',
        '1495',
        '1496',
        '1497',
        '1498',
        '1499',
    ],
    'Kassenbestand, Bundesbankguthaben, Guthaben bei Kreditinstituten und Schecks': [
        '1550',
        '1551',
        '1552',
        '1553',
        '1554',
        '1555',
        '1556',
        '1557',
        '1558',
        '1559',
        '1560',
        '1561',
        '1562',
        '1563',
        '1564',
        '1565',
        '1566',
        '1567',
        '1568',
        '1569',
        '1570',
        '1571',
        '1572',
        '1573',
        '1574',
        '1575',
        '1576',
        '1577',
        '1578',
        '1579',
        '1580',
        '1581',
        '1582',
        '1583',
        '1584',
        '1585',
        '1586',
        '1587',
        '1588',
        '1589',
        '1590',
        '1591',
        '1592',
        '1593',
        '1594',
        '1595',
        '1596',
        '1597',
        '1598',
        '1599',
        '1600',
        '1601',
        '1602',
        '1603',
        '1604',
        '1605',
        '1606',
        '1607',
        '1608',
        '1609',
        '1610',
        '1611',
        '1612',
        '1613',
        '1614',
        '1615',
        '1616',
        '1617',
        '1618',
        '1619',
        '1620',
        '1621',
        '1622',
        '1623',
        '1624',
        '1625',
        '1626',
        '1627',
        '1628',
        '1629',
        '1630',
        '1631',
        '1632',
        '1633',
        '1634',
        '1635',
        '1636',
        '1637',
        '1638',
        '1639',
        '1640',
        '1641',
        '1642',
        '1643',
        '1644',
        '1645',
        '1646',
        '1647',
        '1648',
        '1649',
        '1650',
        '1651',
        '1652',
        '1653',
        '1654',
        '1655',
        '1656',
        '1657',
        '1658',
        '1659',
        '1660',
        '1661',
        '1662',
        '1663',
        '1664',
        '1665',
        '1666',
        '1667',
        '1668',
        '1669',
        '1670',
        '1671',
        '1672',
        '1673',
        '1674',
        '1675',
        '1676',
        '1677',
        '1678',
        '1679',
        '1680',
        '1681',
        '1682',
        '1683',
        '1684',
        '1685',
        '1686',
        '1687',
        '1688',
        '1689',
        '1690',
        '1691',
        '1692',
        '1693',
        '1694',
        '1695',
        '1696',
        '1697',
        '1698',
        '1699',
        '1700',
        '1701',
        '1702',
        '1703',
        '1704',
        '1705',
        '1706',
        '1707',
        '1708',
        '1709',
        '1710',
        '1711',
        '1712',
        '1713',
        '1714',
        '1715',
        '1716',
        '1717',
        '1718',
        '1719',
        '1720',
        '1721',
        '1722',
        '1723',
        '1724',
        '1725',
        '1726',
        '1727',
        '1728',
        '1729',
        '1730',
        '1731',
        '1732',
        '1733',
        '1734',
        '1735',
        '1736',
        '1737',
        '1738',
        '1739',
        '1740',
        '1741',
        '1742',
        '1743',
        '1744',
        '1745',
        '1746',
        '1747',
        '1748',
        '1749',
        '1750',
        '1751',
        '1752',
        '1753',
        '1754',
        '1755',
        '1756',
        '1757',
        '1758',
        '1759',
        '1760',
        '1761',
        '1762',
        '1763',
        '1764',
        '1765',
        '1766',
        '1767',
        '1768',
        '1769',
        '1770',
        '1771',
        '1772',
        '1773',
        '1774',
        '1775',
        '1776',
        '1777',
        '1778',
        '1779',
        '1780',
        '1781',
        '1782',
        '1783',
        '1784',
        '1785',
        '1786',
        '1787',
        '1788',
        '1789',
        '1790',
        '1791',
        '1792',
        '1793',
        '1794',
        '1795',
        '1796',
        '1797',
        '1798',
        '1799',
        '1800',
        '1801',
        '1802',
        '1803',
        '1804',
        '1805',
        '1806',
        '1807',
        '1808',
        '1809',
        '1810',
        '1811',
        '1812',
        '1813',
        '1814',
        '1815',
        '1816',
        '1817',
        '1818',
        '1819',
        '1820',
        '1821',
        '1822',
        '1823',
        '1824',
        '1825',
        '1826',
        '1827',
        '1828',
        '1829',
        '1830',
        '1831',
        '1832',
        '1833',
        '1834',
        '1835',
        '1836',
        '1837',
        '1838',
        '1839',
        '1840',
        '1841',
        '1842',
        '1843',
        '1844',
        '1845',
        '1846',
        '1847',
        '1848',
        '1849',
        '1850',
        '1851',
        '1852',
        '1853',
        '1854',
        '1855',
        '1856',
        '1857',
        '1858',
        '1859',
        '1860',
        '1861',
        '1862',
        '1863',
        '1864',
        '1865',
        '1866',
        '1867',
        '1868',
        '1869',
        '1870',
        '1871',
        '1872',
        '1873',
        '1874',
        '1875',
        '1876',
        '1877',
        '1878',
        '1879',
        '1880',
        '1881',
        '1882',
        '1883',
        '1884',
        '1885',
        '1886',
        '1887',
        '1888',
        '1889',
        '1890',
        '1891',
        '1892',
        '1893',
        '1894',
        '1895',
        '1896',
        '1897',
        '1898',
        '1899',
    ],
    Rechnungsabgrenzungsposten: [
        '1900',
        '1901',
        '1902',
        '1903',
        '1904',
        '1905',
        '1906',
        '1907',
        '1908',
        '1909',
        '1910',
        '1911',
        '1912',
        '1913',
        '1914',
        '1915',
        '1916',
        '1917',
        '1918',
        '1919',
        '1920',
        '1921',
        '1922',
        '1923',
        '1924',
        '1925',
        '1926',
        '1927',
        '1928',
        '1929',
        '1930',
        '1931',
        '1932',
        '1933',
        '1934',
        '1935',
        '1936',
        '1937',
        '1938',
        '1939',
    ],
    'davon Disagio': ['1940', '1941', '1942', '1943', '1944', '1945', '1946', '1947', '1948', '1949'],
    'Gezeichnetes Kapital': [
        '2900',
        '2901',
        '2902',
        '2903',
        '2904',
        '2905',
        '2906',
        '2907',
        '2908',
        '2909',
        '2910',
        '2911',
        '2912',
        '2913',
        '2914',
        '2915',
        '2916',
        '2917',
        '2918',
        '2919',
    ],
    Gewinnrücklagen: [
        '2930',
        '2931',
        '2932',
        '2933',
        '2934',
        '2935',
        '2936',
        '2937',
        '2938',
        '2939',
        '2940',
        '2941',
        '2942',
        '2943',
        '2944',
        '2945',
        '2946',
        '2947',
        '2948',
        '2949',
        '2950',
        '2951',
        '2952',
        '2953',
        '2954',
        '2955',
        '2956',
        '2957',
        '2958',
        '2959',
    ],
    'andere Gewinnrücklagen': ['2960', '2961', '2962', '2963', '2964', '2965', '2966', '2967', '2968', '2969'],
    Bilanzgewinn: [''],
    'davon Gewinnvortrag': ['2970', '2971', '2972', '2973', '2974', '2975', '2976', '2977', '2978', '2979'],
    'Rückstellungen für Pensionen und ähnliche Verpflichtungen': [
        '3000',
        '3001',
        '3002',
        '3003',
        '3004',
        '3005',
        '3006',
        '3007',
        '3008',
        '3009',
        '3010',
        '3011',
        '3012',
        '3013',
        '3014',
        '3015',
        '3016',
        '3017',
        '3018',
        '3019',
    ],
    'sonstige Rückstellungen': [
        '3070',
        '3071',
        '3072',
        '3073',
        '3074',
        '3075',
        '3076',
        '3077',
        '3078',
        '3079',
        '3080',
        '3081',
        '3082',
        '3083',
        '3084',
        '3085',
        '3086',
        '3087',
        '3088',
        '3089',
        '3090',
        '3091',
        '3092',
        '3093',
        '3094',
        '3095',
        '3096',
        '3097',
        '3098',
        '3099',
    ],
    'sonstige Verbindlichkeiten davon gegenüber Gesellschaftern': [
        '3501',
        '3502',
        '3503',
        '3504',
        '3505',
        '3506',
        '3507',
        '3508',
        '3509',
        '3510',
        '3511',
        '3512',
        '3513',
        '3514',
        '3515',
        '3516',
        '3517',
        '3518',
        '3519',
    ],
    'sonstige Verbindlichkeiten davon aus Steuern': [
        '3700',
        '3701',
        '3702',
        '3703',
        '3704',
        '3705',
        '3706',
        '3707',
        '3708',
        '3709',
        '3710',
        '3711',
        '3712',
        '3713',
        '3714',
        '3715',
        '3716',
        '3717',
        '3718',
        '3719',
        '3720',
        '3721',
        '3722',
        '3723',
        '3724',
        '3725',
        '3726',
        '3727',
        '3728',
        '3729',
        '3730',
        '3731',
        '3732',
        '3733',
        '3734',
        '3735',
        '3736',
        '3737',
        '3738',
        '3739',
        '3740',
        '3741',
        '3742',
        '3743',
        '3744',
        '3745',
        '3746',
        '3747',
        '3748',
        '3749',
        '3750',
        '3751',
        '3752',
        '3753',
        '3754',
        '3755',
        '3756',
        '3757',
        '3758',
        '3759',
        '3760',
        '3761',
        '3762',
        '3763',
        '3764',
        '3765',
        '3766',
        '3767',
        '3768',
        '3769',
        '3770',
        '3771',
        '3772',
        '3773',
        '3774',
        '3775',
        '3776',
        '3777',
        '3778',
        '3779',
        '3780',
        '3781',
        '3782',
        '3783',
        '3784',
        '3785',
        '3786',
        '3787',
        '3788',
        '3789',
        '3790',
        '3791',
        '3792',
        '3793',
        '3794',
        '3795',
        '3796',
        '3797',
        '3798',
        '3799',
        '3800',
        '3801',
        '3802',
        '3803',
        '3804',
        '3805',
        '3806',
        '3807',
        '3808',
        '3809',
        '3810',
        '3811',
        '3812',
        '3813',
        '3814',
        '3815',
        '3816',
        '3817',
        '3818',
        '3819',
        '3820',
        '3821',
        '3822',
        '3823',
        '3824',
        '3825',
        '3826',
        '3827',
        '3828',
        '3829',
        '3830',
        '3831',
        '3832',
        '3833',
        '3834',
        '3835',
        '3836',
        '3837',
        '3838',
        '3839',
        '3840',
        '3841',
        '3842',
        '3843',
        '3844',
        '3845',
        '3846',
        '3847',
        '3848',
        '3849',
        '3850',
        '3851',
        '3852',
        '3853',
        '3854',
        '3855',
        '3856',
        '3857',
        '3858',
        '3859',
        '3860',
        '3861',
        '3862',
        '3863',
        '3864',
        '3865',
        '3866',
        '3867',
        '3868',
        '3869',
        '3870',
        '3871',
        '3872',
        '3873',
        '3874',
        '3875',
        '3876',
        '3877',
        '3878',
        '3879',
        '3880',
        '3881',
        '3882',
        '3883',
        '3884',
        '3885',
        '3886',
        '3887',
        '3888',
        '3889',
        '3890',
        '3891',
        '3892',
        '3893',
        '3894',
        '3895',
        '3896',
        '3897',
        '3898',
        '3899',
    ],
    Umsatzerlöse: [
        '4000',
        '4001',
        '4002',
        '4003',
        '4004',
        '4005',
        '4006',
        '4007',
        '4008',
        '4009',
        '4010',
        '4011',
        '4012',
        '4013',
        '4014',
        '4015',
        '4016',
        '4017',
        '4018',
        '4019',
        '4020',
        '4021',
        '4022',
        '4023',
        '4024',
        '4025',
        '4026',
        '4027',
        '4028',
        '4029',
        '4030',
        '4031',
        '4032',
        '4033',
        '4034',
        '4035',
        '4036',
        '4037',
        '4038',
        '4039',
        '4040',
        '4041',
        '4042',
        '4043',
        '4044',
        '4045',
        '4046',
        '4047',
        '4048',
        '4049',
        '4050',
        '4051',
        '4052',
        '4053',
        '4054',
        '4055',
        '4056',
        '4057',
        '4058',
        '4059',
        '4060',
        '4061',
        '4062',
        '4063',
        '4064',
        '4065',
        '4066',
        '4067',
        '4068',
        '4069',
        '4070',
        '4071',
        '4072',
        '4073',
        '4074',
        '4075',
        '4076',
        '4077',
        '4078',
        '4079',
        '4080',
        '4081',
        '4082',
        '4083',
        '4084',
        '4085',
        '4086',
        '4087',
        '4088',
        '4089',
        '4090',
        '4091',
        '4092',
        '4093',
        '4094',
        '4095',
        '4096',
        '4097',
        '4098',
        '4099',
        '4100',
        '4101',
        '4102',
        '4103',
        '4104',
        '4105',
        '4106',
        '4107',
        '4108',
        '4109',
        '4110',
        '4111',
        '4112',
        '4113',
        '4114',
        '4115',
        '4116',
        '4117',
        '4118',
        '4119',
        '4120',
        '4121',
        '4122',
        '4123',
        '4124',
        '4125',
        '4126',
        '4127',
        '4128',
        '4129',
        '4130',
        '4131',
        '4132',
        '4133',
        '4134',
        '4135',
        '4136',
        '4137',
        '4138',
        '4139',
        '4140',
        '4141',
        '4142',
        '4143',
        '4144',
        '4145',
        '4146',
        '4147',
        '4148',
        '4149',
        '4150',
        '4151',
        '4152',
        '4153',
        '4154',
        '4155',
        '4156',
        '4157',
        '4158',
        '4159',
        '4160',
        '4161',
        '4162',
        '4163',
        '4164',
        '4165',
        '4166',
        '4167',
        '4168',
        '4169',
        '4170',
        '4171',
        '4172',
        '4173',
        '4174',
        '4175',
        '4176',
        '4177',
        '4178',
        '4179',
        '4180',
        '4181',
        '4182',
        '4183',
        '4184',
        '4185',
        '4186',
        '4187',
        '4188',
        '4189',
        '4190',
        '4191',
        '4192',
        '4193',
        '4194',
        '4195',
        '4196',
        '4197',
        '4198',
        '4199',
        '4200',
        '4201',
        '4202',
        '4203',
        '4204',
        '4205',
        '4206',
        '4207',
        '4208',
        '4209',
        '4210',
        '4211',
        '4212',
        '4213',
        '4214',
        '4215',
        '4216',
        '4217',
        '4218',
        '4219',
        '4220',
        '4221',
        '4222',
        '4223',
        '4224',
        '4225',
        '4226',
        '4227',
        '4228',
        '4229',
        '4230',
        '4231',
        '4232',
        '4233',
        '4234',
        '4235',
        '4236',
        '4237',
        '4238',
        '4239',
        '4240',
        '4241',
        '4242',
        '4243',
        '4244',
        '4245',
        '4246',
        '4247',
        '4248',
        '4249',
        '4250',
        '4251',
        '4252',
        '4253',
        '4254',
        '4255',
        '4256',
        '4257',
        '4258',
        '4259',
        '4260',
        '4261',
        '4262',
        '4263',
        '4264',
        '4265',
        '4266',
        '4267',
        '4268',
        '4269',
        '4270',
        '4271',
        '4272',
        '4273',
        '4274',
        '4275',
        '4276',
        '4277',
        '4278',
        '4279',
        '4280',
        '4281',
        '4282',
        '4283',
        '4284',
        '4285',
        '4286',
        '4287',
        '4288',
        '4289',
        '4290',
        '4291',
        '4292',
        '4293',
        '4294',
        '4295',
        '4296',
        '4297',
        '4298',
        '4299',
        '4300',
        '4301',
        '4302',
        '4303',
        '4304',
        '4305',
        '4306',
        '4307',
        '4308',
        '4309',
        '4310',
        '4311',
        '4312',
        '4313',
        '4314',
        '4315',
        '4316',
        '4317',
        '4318',
        '4319',
        '4320',
        '4321',
        '4322',
        '4323',
        '4324',
        '4325',
        '4326',
        '4327',
        '4328',
        '4329',
        '4330',
        '4331',
        '4332',
        '4333',
        '4334',
        '4335',
        '4336',
        '4337',
        '4338',
        '4339',
        '4340',
        '4341',
        '4342',
        '4343',
        '4344',
        '4345',
        '4346',
        '4347',
        '4348',
        '4349',
        '4350',
        '4351',
        '4352',
        '4353',
        '4354',
        '4355',
        '4356',
        '4357',
        '4358',
        '4359',
        '4360',
        '4361',
        '4362',
        '4363',
        '4364',
        '4365',
        '4366',
        '4367',
        '4368',
        '4369',
        '4370',
        '4371',
        '4372',
        '4373',
        '4374',
        '4375',
        '4376',
        '4377',
        '4378',
        '4379',
        '4380',
        '4381',
        '4382',
        '4383',
        '4384',
        '4385',
        '4386',
        '4387',
        '4388',
        '4389',
        '4390',
        '4391',
        '4392',
        '4393',
        '4394',
        '4395',
        '4396',
        '4397',
        '4398',
        '4399',
        '4400',
        '4401',
        '4402',
        '4403',
        '4404',
        '4405',
        '4406',
        '4407',
        '4408',
        '4409',
        '4410',
        '4411',
        '4412',
        '4413',
        '4414',
        '4415',
        '4416',
        '4417',
        '4418',
        '4419',
        '4420',
        '4421',
        '4422',
        '4423',
        '4424',
        '4425',
        '4426',
        '4427',
        '4428',
        '4429',
        '4430',
        '4431',
        '4432',
        '4433',
        '4434',
        '4435',
        '4436',
        '4437',
        '4438',
        '4439',
        '4440',
        '4441',
        '4442',
        '4443',
        '4444',
        '4445',
        '4446',
        '4447',
        '4448',
        '4449',
        '4450',
        '4451',
        '4452',
        '4453',
        '4454',
        '4455',
        '4456',
        '4457',
        '4458',
        '4459',
        '4460',
        '4461',
        '4462',
        '4463',
        '4464',
        '4465',
        '4466',
        '4467',
        '4468',
        '4469',
        '4470',
        '4471',
        '4472',
        '4473',
        '4474',
        '4475',
        '4476',
        '4477',
        '4478',
        '4479',
        '4480',
        '4481',
        '4482',
        '4483',
        '4484',
        '4485',
        '4486',
        '4487',
        '4488',
        '4489',
        '4490',
        '4491',
        '4492',
        '4493',
        '4494',
        '4495',
        '4496',
        '4497',
        '4498',
        '4499',
        '4500',
        '4501',
        '4502',
        '4503',
        '4504',
        '4505',
        '4506',
        '4507',
        '4508',
        '4509',
        '4510',
        '4511',
        '4512',
        '4513',
        '4514',
        '4515',
        '4516',
        '4517',
        '4518',
        '4519',
        '4520',
        '4521',
        '4522',
        '4523',
        '4524',
        '4525',
        '4526',
        '4527',
        '4528',
        '4529',
        '4530',
        '4531',
        '4532',
        '4533',
        '4534',
        '4535',
        '4536',
        '4537',
        '4538',
        '4539',
        '4540',
        '4541',
        '4542',
        '4543',
        '4544',
        '4545',
        '4546',
        '4547',
        '4548',
        '4549',
        '4550',
        '4551',
        '4552',
        '4553',
        '4554',
        '4555',
        '4556',
        '4557',
        '4558',
        '4559',
        '4560',
        '4561',
        '4562',
        '4563',
        '4564',
        '4565',
        '4566',
        '4567',
        '4568',
        '4569',
        '4570',
        '4571',
        '4572',
        '4573',
        '4574',
        '4575',
        '4576',
        '4577',
        '4578',
        '4579',
        '4580',
        '4581',
        '4582',
        '4583',
        '4584',
        '4585',
        '4586',
        '4587',
        '4588',
        '4589',
        '4590',
        '4591',
        '4592',
        '4593',
        '4594',
        '4595',
        '4596',
        '4597',
        '4598',
        '4599',
        '4600',
        '4601',
        '4602',
        '4603',
        '4604',
        '4605',
        '4606',
        '4607',
        '4608',
        '4609',
        '4610',
        '4611',
        '4612',
        '4613',
        '4614',
        '4615',
        '4616',
        '4617',
        '4618',
        '4619',
        '4620',
        '4621',
        '4622',
        '4623',
        '4624',
        '4625',
        '4626',
        '4627',
        '4628',
        '4629',
        '4630',
        '4631',
        '4632',
        '4633',
        '4634',
        '4635',
        '4636',
        '4637',
        '4638',
        '4639',
        '4640',
        '4641',
        '4642',
        '4643',
        '4644',
        '4645',
        '4646',
        '4647',
        '4648',
        '4649',
        '4650',
        '4651',
        '4652',
        '4653',
        '4654',
        '4655',
        '4656',
        '4657',
        '4658',
        '4659',
        '4660',
        '4661',
        '4662',
        '4663',
        '4664',
        '4665',
        '4666',
        '4667',
        '4668',
        '4669',
        '4670',
        '4671',
        '4672',
        '4673',
        '4674',
        '4675',
        '4676',
        '4677',
        '4678',
        '4679',
        '4680',
        '4681',
        '4682',
        '4683',
        '4684',
        '4685',
        '4686',
        '4687',
        '4688',
        '4689',
        '4690',
        '4691',
        '4692',
        '4693',
        '4694',
        '4695',
        '4696',
        '4697',
        '4698',
        '4699',
        '4700',
        '4701',
        '4702',
        '4703',
        '4704',
        '4705',
        '4706',
        '4707',
        '4708',
        '4709',
        '4710',
        '4711',
        '4712',
        '4713',
        '4714',
        '4715',
        '4716',
        '4717',
        '4718',
        '4719',
        '4720',
        '4721',
        '4722',
        '4723',
        '4724',
        '4725',
        '4726',
        '4727',
        '4728',
        '4729',
        '4730',
        '4731',
        '4732',
        '4733',
        '4734',
        '4735',
        '4736',
        '4737',
        '4738',
        '4739',
        '4740',
        '4741',
        '4742',
        '4743',
        '4744',
        '4745',
        '4746',
        '4747',
        '4748',
        '4749',
        '4750',
        '4751',
        '4752',
        '4753',
        '4754',
        '4755',
        '4756',
        '4757',
        '4758',
        '4759',
        '4760',
        '4761',
        '4762',
        '4763',
        '4764',
        '4765',
        '4766',
        '4767',
        '4768',
        '4769',
        '4770',
        '4771',
        '4772',
        '4773',
        '4774',
        '4775',
        '4776',
        '4777',
        '4778',
        '4779',
        '4780',
        '4781',
        '4782',
        '4783',
        '4784',
        '4785',
        '4786',
        '4787',
        '4788',
        '4789',
        '4790',
        '4791',
        '4792',
        '4793',
        '4794',
        '4795',
        '4796',
        '4797',
        '4798',
        '4799',
    ],
    'Erhöhung des Bestandes an fertigen und unfertigen Erzeugnissen': [
        '4800',
        '4801',
        '4802',
        '4803',
        '4804',
        '4805',
        '4806',
        '4807',
        '4808',
        '4809',
        '4810',
        '4811',
        '4812',
        '4813',
        '4814',
        '4815',
        '4816',
        '4817',
        '4818',
        '4819',
        '4820',
        '4821',
        '4822',
        '4823',
        '4824',
        '4825',
        '4826',
        '4827',
        '4828',
        '4829',
    ],
    'sonstige betriebliche Erträge': [
        '4830',
        '4831',
        '4832',
        '4833',
        '4834',
        '4835',
        '4836',
        '4837',
        '4838',
        '4839',
        '4840',
        '4841',
        '4842',
        '4843',
        '4844',
        '4845',
        '4846',
        '4847',
        '4848',
        '4849',
        '4850',
        '4851',
        '4852',
        '4853',
        '4854',
        '4855',
        '4856',
        '4857',
        '4858',
        '4859',
        '4860',
        '4861',
        '4862',
        '4863',
        '4864',
        '4865',
        '4866',
        '4867',
        '4868',
        '4869',
        '4870',
        '4871',
        '4872',
        '4873',
        '4874',
        '4875',
        '4876',
        '4877',
        '4878',
        '4879',
        '4880',
        '4881',
        '4882',
        '4883',
        '4884',
        '4885',
        '4886',
        '4887',
        '4888',
        '4889',
        '4890',
        '4891',
        '4892',
        '4893',
        '4894',
        '4895',
        '4896',
        '4897',
        '4898',
        '4899',
        '4900',
        '4901',
        '4902',
        '4903',
        '4904',
        '4905',
        '4906',
        '4907',
        '4908',
        '4909',
        '4910',
        '4911',
        '4912',
        '4913',
        '4914',
        '4915',
        '4916',
        '4917',
        '4918',
        '4919',
        '4920',
        '4921',
        '4922',
        '4923',
        '4924',
        '4925',
        '4926',
        '4927',
        '4928',
        '4929',
        '4930',
        '4931',
        '4932',
        '4933',
        '4934',
        '4935',
        '4936',
        '4937',
        '4938',
        '4939',
        '4940',
        '4941',
        '4942',
        '4943',
        '4944',
        '4945',
        '4946',
        '4947',
        '4948',
        '4949',
        '4950',
        '4951',
        '4952',
        '4953',
        '4954',
        '4955',
        '4956',
        '4957',
        '4958',
        '4959',
        '4960',
        '4961',
        '4962',
        '4963',
        '4964',
        '4965',
        '4966',
        '4967',
        '4968',
        '4969',
        '4970',
        '4971',
        '4972',
        '4973',
        '4974',
        '4975',
        '4976',
        '4977',
        '4978',
        '4979',
        '4980',
        '4981',
        '4982',
        '4983',
        '4984',
        '4985',
        '4986',
        '4987',
        '4988',
        '4989',
        '4990',
        '4991',
        '4992',
        '4993',
        '4994',
        '4995',
        '4996',
        '4997',
        '4998',
        '4999',
    ],
    Materialaufwand: [
        '5000',
        '5001',
        '5002',
        '5003',
        '5004',
        '5005',
        '5006',
        '5007',
        '5008',
        '5009',
        '5010',
        '5011',
        '5012',
        '5013',
        '5014',
        '5015',
        '5016',
        '5017',
        '5018',
        '5019',
        '5020',
        '5021',
        '5022',
        '5023',
        '5024',
        '5025',
        '5026',
        '5027',
        '5028',
        '5029',
        '5030',
        '5031',
        '5032',
        '5033',
        '5034',
        '5035',
        '5036',
        '5037',
        '5038',
        '5039',
        '5040',
        '5041',
        '5042',
        '5043',
        '5044',
        '5045',
        '5046',
        '5047',
        '5048',
        '5049',
        '5050',
        '5051',
        '5052',
        '5053',
        '5054',
        '5055',
        '5056',
        '5057',
        '5058',
        '5059',
        '5060',
        '5061',
        '5062',
        '5063',
        '5064',
        '5065',
        '5066',
        '5067',
        '5068',
        '5069',
        '5070',
        '5071',
        '5072',
        '5073',
        '5074',
        '5075',
        '5076',
        '5077',
        '5078',
        '5079',
        '5080',
        '5081',
        '5082',
        '5083',
        '5084',
        '5085',
        '5086',
        '5087',
        '5088',
        '5089',
        '5090',
        '5091',
        '5092',
        '5093',
        '5094',
        '5095',
        '5096',
        '5097',
        '5098',
        '5099',
        '5100',
        '5101',
        '5102',
        '5103',
        '5104',
        '5105',
        '5106',
        '5107',
        '5108',
        '5109',
        '5110',
        '5111',
        '5112',
        '5113',
        '5114',
        '5115',
        '5116',
        '5117',
        '5118',
        '5119',
        '5120',
        '5121',
        '5122',
        '5123',
        '5124',
        '5125',
        '5126',
        '5127',
        '5128',
        '5129',
        '5130',
        '5131',
        '5132',
        '5133',
        '5134',
        '5135',
        '5136',
        '5137',
        '5138',
        '5139',
        '5140',
        '5141',
        '5142',
        '5143',
        '5144',
        '5145',
        '5146',
        '5147',
        '5148',
        '5149',
        '5150',
        '5151',
        '5152',
        '5153',
        '5154',
        '5155',
        '5156',
        '5157',
        '5158',
        '5159',
        '5160',
        '5161',
        '5162',
        '5163',
        '5164',
        '5165',
        '5166',
        '5167',
        '5168',
        '5169',
        '5170',
        '5171',
        '5172',
        '5173',
        '5174',
        '5175',
        '5176',
        '5177',
        '5178',
        '5179',
        '5180',
        '5181',
        '5182',
        '5183',
        '5184',
        '5185',
        '5186',
        '5187',
        '5188',
        '5189',
        '5190',
        '5191',
        '5192',
        '5193',
        '5194',
        '5195',
        '5196',
        '5197',
        '5198',
        '5199',
        '5200',
        '5201',
        '5202',
        '5203',
        '5204',
        '5205',
        '5206',
        '5207',
        '5208',
        '5209',
        '5210',
        '5211',
        '5212',
        '5213',
        '5214',
        '5215',
        '5216',
        '5217',
        '5218',
        '5219',
        '5220',
        '5221',
        '5222',
        '5223',
        '5224',
        '5225',
        '5226',
        '5227',
        '5228',
        '5229',
        '5230',
        '5231',
        '5232',
        '5233',
        '5234',
        '5235',
        '5236',
        '5237',
        '5238',
        '5239',
        '5240',
        '5241',
        '5242',
        '5243',
        '5244',
        '5245',
        '5246',
        '5247',
        '5248',
        '5249',
        '5250',
        '5251',
        '5252',
        '5253',
        '5254',
        '5255',
        '5256',
        '5257',
        '5258',
        '5259',
        '5260',
        '5261',
        '5262',
        '5263',
        '5264',
        '5265',
        '5266',
        '5267',
        '5268',
        '5269',
        '5270',
        '5271',
        '5272',
        '5273',
        '5274',
        '5275',
        '5276',
        '5277',
        '5278',
        '5279',
        '5280',
        '5281',
        '5282',
        '5283',
        '5284',
        '5285',
        '5286',
        '5287',
        '5288',
        '5289',
        '5290',
        '5291',
        '5292',
        '5293',
        '5294',
        '5295',
        '5296',
        '5297',
        '5298',
        '5299',
        '5300',
        '5301',
        '5302',
        '5303',
        '5304',
        '5305',
        '5306',
        '5307',
        '5308',
        '5309',
        '5310',
        '5311',
        '5312',
        '5313',
        '5314',
        '5315',
        '5316',
        '5317',
        '5318',
        '5319',
        '5320',
        '5321',
        '5322',
        '5323',
        '5324',
        '5325',
        '5326',
        '5327',
        '5328',
        '5329',
        '5330',
        '5331',
        '5332',
        '5333',
        '5334',
        '5335',
        '5336',
        '5337',
        '5338',
        '5339',
        '5340',
        '5341',
        '5342',
        '5343',
        '5344',
        '5345',
        '5346',
        '5347',
        '5348',
        '5349',
        '5350',
        '5351',
        '5352',
        '5353',
        '5354',
        '5355',
        '5356',
        '5357',
        '5358',
        '5359',
        '5360',
        '5361',
        '5362',
        '5363',
        '5364',
        '5365',
        '5366',
        '5367',
        '5368',
        '5369',
        '5370',
        '5371',
        '5372',
        '5373',
        '5374',
        '5375',
        '5376',
        '5377',
        '5378',
        '5379',
        '5380',
        '5381',
        '5382',
        '5383',
        '5384',
        '5385',
        '5386',
        '5387',
        '5388',
        '5389',
        '5390',
        '5391',
        '5392',
        '5393',
        '5394',
        '5395',
        '5396',
        '5397',
        '5398',
        '5399',
        '5400',
        '5401',
        '5402',
        '5403',
        '5404',
        '5405',
        '5406',
        '5407',
        '5408',
        '5409',
        '5410',
        '5411',
        '5412',
        '5413',
        '5414',
        '5415',
        '5416',
        '5417',
        '5418',
        '5419',
        '5420',
        '5421',
        '5422',
        '5423',
        '5424',
        '5425',
        '5426',
        '5427',
        '5428',
        '5429',
        '5430',
        '5431',
        '5432',
        '5433',
        '5434',
        '5435',
        '5436',
        '5437',
        '5438',
        '5439',
        '5440',
        '5441',
        '5442',
        '5443',
        '5444',
        '5445',
        '5446',
        '5447',
        '5448',
        '5449',
        '5450',
        '5451',
        '5452',
        '5453',
        '5454',
        '5455',
        '5456',
        '5457',
        '5458',
        '5459',
        '5460',
        '5461',
        '5462',
        '5463',
        '5464',
        '5465',
        '5466',
        '5467',
        '5468',
        '5469',
        '5470',
        '5471',
        '5472',
        '5473',
        '5474',
        '5475',
        '5476',
        '5477',
        '5478',
        '5479',
        '5480',
        '5481',
        '5482',
        '5483',
        '5484',
        '5485',
        '5486',
        '5487',
        '5488',
        '5489',
        '5490',
        '5491',
        '5492',
        '5493',
        '5494',
        '5495',
        '5496',
        '5497',
        '5498',
        '5499',
        '5500',
        '5501',
        '5502',
        '5503',
        '5504',
        '5505',
        '5506',
        '5507',
        '5508',
        '5509',
        '5510',
        '5511',
        '5512',
        '5513',
        '5514',
        '5515',
        '5516',
        '5517',
        '5518',
        '5519',
        '5520',
        '5521',
        '5522',
        '5523',
        '5524',
        '5525',
        '5526',
        '5527',
        '5528',
        '5529',
        '5530',
        '5531',
        '5532',
        '5533',
        '5534',
        '5535',
        '5536',
        '5537',
        '5538',
        '5539',
        '5540',
        '5541',
        '5542',
        '5543',
        '5544',
        '5545',
        '5546',
        '5547',
        '5548',
        '5549',
        '5550',
        '5551',
        '5552',
        '5553',
        '5554',
        '5555',
        '5556',
        '5557',
        '5558',
        '5559',
        '5560',
        '5561',
        '5562',
        '5563',
        '5564',
        '5565',
        '5566',
        '5567',
        '5568',
        '5569',
        '5570',
        '5571',
        '5572',
        '5573',
        '5574',
        '5575',
        '5576',
        '5577',
        '5578',
        '5579',
        '5580',
        '5581',
        '5582',
        '5583',
        '5584',
        '5585',
        '5586',
        '5587',
        '5588',
        '5589',
        '5590',
        '5591',
        '5592',
        '5593',
        '5594',
        '5595',
        '5596',
        '5597',
        '5598',
        '5599',
        '5600',
        '5601',
        '5602',
        '5603',
        '5604',
        '5605',
        '5606',
        '5607',
        '5608',
        '5609',
        '5610',
        '5611',
        '5612',
        '5613',
        '5614',
        '5615',
        '5616',
        '5617',
        '5618',
        '5619',
        '5620',
        '5621',
        '5622',
        '5623',
        '5624',
        '5625',
        '5626',
        '5627',
        '5628',
        '5629',
        '5630',
        '5631',
        '5632',
        '5633',
        '5634',
        '5635',
        '5636',
        '5637',
        '5638',
        '5639',
        '5640',
        '5641',
        '5642',
        '5643',
        '5644',
        '5645',
        '5646',
        '5647',
        '5648',
        '5649',
        '5650',
        '5651',
        '5652',
        '5653',
        '5654',
        '5655',
        '5656',
        '5657',
        '5658',
        '5659',
        '5660',
        '5661',
        '5662',
        '5663',
        '5664',
        '5665',
        '5666',
        '5667',
        '5668',
        '5669',
        '5670',
        '5671',
        '5672',
        '5673',
        '5674',
        '5675',
        '5676',
        '5677',
        '5678',
        '5679',
        '5680',
        '5681',
        '5682',
        '5683',
        '5684',
        '5685',
        '5686',
        '5687',
        '5688',
        '5689',
        '5690',
        '5691',
        '5692',
        '5693',
        '5694',
        '5695',
        '5696',
        '5697',
        '5698',
        '5699',
        '5700',
        '5701',
        '5702',
        '5703',
        '5704',
        '5705',
        '5706',
        '5707',
        '5708',
        '5709',
        '5710',
        '5711',
        '5712',
        '5713',
        '5714',
        '5715',
        '5716',
        '5717',
        '5718',
        '5719',
        '5720',
        '5721',
        '5722',
        '5723',
        '5724',
        '5725',
        '5726',
        '5727',
        '5728',
        '5729',
        '5730',
        '5731',
        '5732',
        '5733',
        '5734',
        '5735',
        '5736',
        '5737',
        '5738',
        '5739',
        '5740',
        '5741',
        '5742',
        '5743',
        '5744',
        '5745',
        '5746',
        '5747',
        '5748',
        '5749',
        '5750',
        '5751',
        '5752',
        '5753',
        '5754',
        '5755',
        '5756',
        '5757',
        '5758',
        '5759',
        '5760',
        '5761',
        '5762',
        '5763',
        '5764',
        '5765',
        '5766',
        '5767',
        '5768',
        '5769',
        '5770',
        '5771',
        '5772',
        '5773',
        '5774',
        '5775',
        '5776',
        '5777',
        '5778',
        '5779',
        '5780',
        '5781',
        '5782',
        '5783',
        '5784',
        '5785',
        '5786',
        '5787',
        '5788',
        '5789',
        '5790',
        '5791',
        '5792',
        '5793',
        '5794',
        '5795',
        '5796',
        '5797',
        '5798',
        '5799',
        '5800',
        '5801',
        '5802',
        '5803',
        '5804',
        '5805',
        '5806',
        '5807',
        '5808',
        '5809',
        '5810',
        '5811',
        '5812',
        '5813',
        '5814',
        '5815',
        '5816',
        '5817',
        '5818',
        '5819',
        '5820',
        '5821',
        '5822',
        '5823',
        '5824',
        '5825',
        '5826',
        '5827',
        '5828',
        '5829',
        '5830',
        '5831',
        '5832',
        '5833',
        '5834',
        '5835',
        '5836',
        '5837',
        '5838',
        '5839',
        '5840',
        '5841',
        '5842',
        '5843',
        '5844',
        '5845',
        '5846',
        '5847',
        '5848',
        '5849',
        '5850',
        '5851',
        '5852',
        '5853',
        '5854',
        '5855',
        '5856',
        '5857',
        '5858',
        '5859',
        '5860',
        '5861',
        '5862',
        '5863',
        '5864',
        '5865',
        '5866',
        '5867',
        '5868',
        '5869',
        '5870',
        '5871',
        '5872',
        '5873',
        '5874',
        '5875',
        '5876',
        '5877',
        '5878',
        '5879',
        '5880',
        '5881',
        '5882',
        '5883',
        '5884',
        '5885',
        '5886',
        '5887',
        '5888',
        '5889',
        '5890',
        '5891',
        '5892',
        '5893',
        '5894',
        '5895',
        '5896',
        '5897',
        '5898',
        '5899',
        '5900',
        '5901',
        '5902',
        '5903',
        '5904',
        '5905',
        '5906',
        '5907',
        '5908',
        '5909',
        '5910',
        '5911',
        '5912',
        '5913',
        '5914',
        '5915',
        '5916',
        '5917',
        '5918',
        '5919',
        '5920',
        '5921',
        '5922',
        '5923',
        '5924',
        '5925',
        '5926',
        '5927',
        '5928',
        '5929',
        '5930',
        '5931',
        '5932',
        '5933',
        '5934',
        '5935',
        '5936',
        '5937',
        '5938',
        '5939',
        '5940',
        '5941',
        '5942',
        '5943',
        '5944',
        '5945',
        '5946',
        '5947',
        '5948',
        '5949',
        '5950',
        '5951',
        '5952',
        '5953',
        '5954',
        '5955',
        '5956',
        '5957',
        '5958',
        '5959',
        '5960',
        '5961',
        '5962',
        '5963',
        '5964',
        '5965',
        '5966',
        '5967',
        '5968',
        '5969',
        '5970',
        '5971',
        '5972',
        '5973',
        '5974',
        '5975',
        '5976',
        '5977',
        '5978',
        '5979',
        '5980',
        '5981',
        '5982',
        '5983',
        '5984',
        '5985',
        '5986',
        '5987',
        '5988',
        '5989',
        '5990',
        '5991',
        '5992',
        '5993',
        '5994',
        '5995',
        '5996',
        '5997',
        '5998',
        '5999',
    ],
    Personalaufwand: [
        '6000',
        '6001',
        '6002',
        '6003',
        '6004',
        '6005',
        '6006',
        '6007',
        '6008',
        '6009',
        '6010',
        '6011',
        '6012',
        '6013',
        '6014',
        '6015',
        '6016',
        '6017',
        '6018',
        '6019',
        '6020',
        '6021',
        '6022',
        '6023',
        '6024',
        '6025',
        '6026',
        '6027',
        '6028',
        '6029',
        '6030',
        '6031',
        '6032',
        '6033',
        '6034',
        '6035',
        '6036',
        '6037',
        '6038',
        '6039',
        '6040',
        '6041',
        '6042',
        '6043',
        '6044',
        '6045',
        '6046',
        '6047',
        '6048',
        '6049',
        '6050',
        '6051',
        '6052',
        '6053',
        '6054',
        '6055',
        '6056',
        '6057',
        '6058',
        '6059',
        '6060',
        '6061',
        '6062',
        '6063',
        '6064',
        '6065',
        '6066',
        '6067',
        '6068',
        '6069',
        '6070',
        '6071',
        '6072',
        '6073',
        '6074',
        '6075',
        '6076',
        '6077',
        '6078',
        '6079',
        '6080',
        '6081',
        '6082',
        '6083',
        '6084',
        '6085',
        '6086',
        '6087',
        '6088',
        '6089',
        '6090',
        '6091',
        '6092',
        '6093',
        '6094',
        '6095',
        '6096',
        '6097',
        '6098',
        '6099',
        '6100',
        '6101',
        '6102',
        '6103',
        '6104',
        '6105',
        '6106',
        '6107',
        '6108',
        '6109',
        '6110',
        '6111',
        '6112',
        '6113',
        '6114',
        '6115',
        '6116',
        '6117',
        '6118',
        '6119',
        '6120',
        '6121',
        '6122',
        '6123',
        '6124',
        '6125',
        '6126',
        '6127',
        '6128',
        '6129',
        '6130',
        '6131',
        '6132',
        '6133',
        '6134',
        '6135',
        '6136',
        '6137',
        '6138',
        '6139',
        '6140',
        '6141',
        '6142',
        '6143',
        '6144',
        '6145',
        '6146',
        '6147',
        '6148',
        '6149',
        '6150',
        '6151',
        '6152',
        '6153',
        '6154',
        '6155',
        '6156',
        '6157',
        '6158',
        '6159',
        '6160',
        '6161',
        '6162',
        '6163',
        '6164',
        '6165',
        '6166',
        '6167',
        '6168',
        '6169',
        '6170',
        '6171',
        '6172',
        '6173',
        '6174',
        '6175',
        '6176',
        '6177',
        '6178',
        '6179',
        '6180',
        '6181',
        '6182',
        '6183',
        '6184',
        '6185',
        '6186',
        '6187',
        '6188',
        '6189',
        '6190',
        '6191',
        '6192',
        '6193',
        '6194',
        '6195',
        '6196',
        '6197',
        '6198',
        '6199',
    ],
    Abschreibungen: [
        '6200',
        '6201',
        '6202',
        '6203',
        '6204',
        '6205',
        '6206',
        '6207',
        '6208',
        '6209',
        '6210',
        '6211',
        '6212',
        '6213',
        '6214',
        '6215',
        '6216',
        '6217',
        '6218',
        '6219',
        '6220',
        '6221',
        '6222',
        '6223',
        '6224',
        '6225',
        '6226',
        '6227',
        '6228',
        '6229',
        '6230',
        '6231',
        '6232',
        '6233',
        '6234',
        '6235',
        '6236',
        '6237',
        '6238',
        '6239',
        '6240',
        '6241',
        '6242',
        '6243',
        '6244',
        '6245',
        '6246',
        '6247',
        '6248',
        '6249',
        '6250',
        '6251',
        '6252',
        '6253',
        '6254',
        '6255',
        '6256',
        '6257',
        '6258',
        '6259',
        '6260',
        '6261',
        '6262',
        '6263',
        '6264',
        '6265',
        '6266',
        '6267',
        '6268',
        '6269',
        '6270',
        '6271',
        '6272',
        '6273',
        '6274',
        '6275',
        '6276',
        '6277',
        '6278',
        '6279',
        '6280',
        '6281',
        '6282',
        '6283',
        '6284',
        '6285',
        '6286',
        '6287',
        '6288',
        '6289',
        '6290',
        '6291',
        '6292',
        '6293',
        '6294',
        '6295',
        '6296',
        '6297',
        '6298',
        '6299',
    ],
    'sonstige betriebliche Aufwendungen': [
        '6300',
        '6301',
        '6302',
        '6303',
        '6304',
        '6305',
        '6306',
        '6307',
        '6308',
        '6309',
        '6310',
        '6311',
        '6312',
        '6313',
        '6314',
        '6315',
        '6316',
        '6317',
        '6318',
        '6319',
        '6320',
        '6321',
        '6322',
        '6323',
        '6324',
        '6325',
        '6326',
        '6327',
        '6328',
        '6329',
        '6330',
        '6331',
        '6332',
        '6333',
        '6334',
        '6335',
        '6336',
        '6337',
        '6338',
        '6339',
        '6340',
        '6341',
        '6342',
        '6343',
        '6344',
        '6345',
        '6346',
        '6347',
        '6348',
        '6349',
        '6350',
        '6351',
        '6352',
        '6353',
        '6354',
        '6355',
        '6356',
        '6357',
        '6358',
        '6359',
        '6360',
        '6361',
        '6362',
        '6363',
        '6364',
        '6365',
        '6366',
        '6367',
        '6368',
        '6369',
        '6370',
        '6371',
        '6372',
        '6373',
        '6374',
        '6375',
        '6376',
        '6377',
        '6378',
        '6379',
        '6380',
        '6381',
        '6382',
        '6383',
        '6384',
        '6385',
        '6386',
        '6387',
        '6388',
        '6389',
        '6390',
        '6391',
        '6392',
        '6393',
        '6394',
        '6395',
        '6396',
        '6397',
        '6398',
        '6399',
        '6400',
        '6401',
        '6402',
        '6403',
        '6404',
        '6405',
        '6406',
        '6407',
        '6408',
        '6409',
        '6410',
        '6411',
        '6412',
        '6413',
        '6414',
        '6415',
        '6416',
        '6417',
        '6418',
        '6419',
        '6420',
        '6421',
        '6422',
        '6423',
        '6424',
        '6425',
        '6426',
        '6427',
        '6428',
        '6429',
        '6430',
        '6431',
        '6432',
        '6433',
        '6434',
        '6435',
        '6436',
        '6437',
        '6438',
        '6439',
        '6440',
        '6441',
        '6442',
        '6443',
        '6444',
        '6445',
        '6446',
        '6447',
        '6448',
        '6449',
        '6450',
        '6451',
        '6452',
        '6453',
        '6454',
        '6455',
        '6456',
        '6457',
        '6458',
        '6459',
        '6460',
        '6461',
        '6462',
        '6463',
        '6464',
        '6465',
        '6466',
        '6467',
        '6468',
        '6469',
        '6470',
        '6471',
        '6472',
        '6473',
        '6474',
        '6475',
        '6476',
        '6477',
        '6478',
        '6479',
        '6480',
        '6481',
        '6482',
        '6483',
        '6484',
        '6485',
        '6486',
        '6487',
        '6488',
        '6489',
        '6490',
        '6491',
        '6492',
        '6493',
        '6494',
        '6495',
        '6496',
        '6497',
        '6498',
        '6499',
        '6500',
        '6501',
        '6502',
        '6503',
        '6504',
        '6505',
        '6506',
        '6507',
        '6508',
        '6509',
        '6510',
        '6511',
        '6512',
        '6513',
        '6514',
        '6515',
        '6516',
        '6517',
        '6518',
        '6519',
        '6520',
        '6521',
        '6522',
        '6523',
        '6524',
        '6525',
        '6526',
        '6527',
        '6528',
        '6529',
        '6530',
        '6531',
        '6532',
        '6533',
        '6534',
        '6535',
        '6536',
        '6537',
        '6538',
        '6539',
        '6540',
        '6541',
        '6542',
        '6543',
        '6544',
        '6545',
        '6546',
        '6547',
        '6548',
        '6549',
        '6550',
        '6551',
        '6552',
        '6553',
        '6554',
        '6555',
        '6556',
        '6557',
        '6558',
        '6559',
        '6560',
        '6561',
        '6562',
        '6563',
        '6564',
        '6565',
        '6566',
        '6567',
        '6568',
        '6569',
        '6570',
        '6571',
        '6572',
        '6573',
        '6574',
        '6575',
        '6576',
        '6577',
        '6578',
        '6579',
        '6580',
        '6581',
        '6582',
        '6583',
        '6584',
        '6585',
        '6586',
        '6587',
        '6588',
        '6589',
        '6590',
        '6591',
        '6592',
        '6593',
        '6594',
        '6595',
        '6596',
        '6597',
        '6598',
        '6599',
        '6600',
        '6601',
        '6602',
        '6603',
        '6604',
        '6605',
        '6606',
        '6607',
        '6608',
        '6609',
        '6610',
        '6611',
        '6612',
        '6613',
        '6614',
        '6615',
        '6616',
        '6617',
        '6618',
        '6619',
        '6620',
        '6621',
        '6622',
        '6623',
        '6624',
        '6625',
        '6626',
        '6627',
        '6628',
        '6629',
        '6630',
        '6631',
        '6632',
        '6633',
        '6634',
        '6635',
        '6636',
        '6637',
        '6638',
        '6639',
        '6640',
        '6641',
        '6642',
        '6643',
        '6644',
        '6645',
        '6646',
        '6647',
        '6648',
        '6649',
        '6650',
        '6651',
        '6652',
        '6653',
        '6654',
        '6655',
        '6656',
        '6657',
        '6658',
        '6659',
        '6660',
        '6661',
        '6662',
        '6663',
        '6664',
        '6665',
        '6666',
        '6667',
        '6668',
        '6669',
        '6670',
        '6671',
        '6672',
        '6673',
        '6674',
        '6675',
        '6676',
        '6677',
        '6678',
        '6679',
        '6680',
        '6681',
        '6682',
        '6683',
        '6684',
        '6685',
        '6686',
        '6687',
        '6688',
        '6689',
        '6690',
        '6691',
        '6692',
        '6693',
        '6694',
        '6695',
        '6696',
        '6697',
        '6698',
        '6699',
        '6700',
        '6701',
        '6702',
        '6703',
        '6704',
        '6705',
        '6706',
        '6707',
        '6708',
        '6709',
        '6710',
        '6711',
        '6712',
        '6713',
        '6714',
        '6715',
        '6716',
        '6717',
        '6718',
        '6719',
        '6720',
        '6721',
        '6722',
        '6723',
        '6724',
        '6725',
        '6726',
        '6727',
        '6728',
        '6729',
        '6730',
        '6731',
        '6732',
        '6733',
        '6734',
        '6735',
        '6736',
        '6737',
        '6738',
        '6739',
        '6740',
        '6741',
        '6742',
        '6743',
        '6744',
        '6745',
        '6746',
        '6747',
        '6748',
        '6749',
        '6750',
        '6751',
        '6752',
        '6753',
        '6754',
        '6755',
        '6756',
        '6757',
        '6758',
        '6759',
        '6760',
        '6761',
        '6762',
        '6763',
        '6764',
        '6765',
        '6766',
        '6767',
        '6768',
        '6769',
        '6770',
        '6771',
        '6772',
        '6773',
        '6774',
        '6775',
        '6776',
        '6777',
        '6778',
        '6779',
        '6780',
        '6781',
        '6782',
        '6783',
        '6784',
        '6785',
        '6786',
        '6787',
        '6788',
        '6789',
        '6790',
        '6791',
        '6792',
        '6793',
        '6794',
        '6795',
        '6796',
        '6797',
        '6798',
        '6799',
        '6800',
        '6801',
        '6802',
        '6803',
        '6804',
        '6805',
        '6806',
        '6807',
        '6808',
        '6809',
        '6810',
        '6811',
        '6812',
        '6813',
        '6814',
        '6815',
        '6816',
        '6817',
        '6818',
        '6819',
        '6820',
        '6821',
        '6822',
        '6823',
        '6824',
        '6825',
        '6826',
        '6827',
        '6828',
        '6829',
        '6830',
        '6831',
        '6832',
        '6833',
        '6834',
        '6835',
        '6836',
        '6837',
        '6838',
        '6839',
        '6840',
        '6841',
        '6842',
        '6843',
        '6844',
        '6845',
        '6846',
        '6847',
        '6848',
        '6849',
        '6850',
        '6851',
        '6852',
        '6853',
        '6854',
        '6855',
        '6856',
        '6857',
        '6858',
        '6859',
        '6860',
        '6861',
        '6862',
        '6863',
        '6864',
        '6865',
        '6866',
        '6867',
        '6868',
        '6869',
        '6870',
        '6871',
        '6872',
        '6873',
        '6874',
        '6875',
        '6876',
        '6877',
        '6878',
        '6879',
        '6880',
        '6881',
        '6882',
        '6883',
        '6884',
        '6885',
        '6886',
        '6887',
        '6888',
        '6889',
        '6890',
        '6891',
        '6892',
        '6893',
        '6894',
        '6895',
        '6896',
        '6897',
        '6898',
        '6899',
        '6900',
        '6901',
        '6902',
        '6903',
        '6904',
        '6905',
        '6906',
        '6907',
        '6908',
        '6909',
        '6910',
        '6911',
        '6912',
        '6913',
        '6914',
        '6915',
        '6916',
        '6917',
        '6918',
        '6919',
        '6920',
        '6921',
        '6922',
        '6923',
        '6924',
        '6925',
        '6926',
        '6927',
        '6928',
        '6929',
        '6930',
        '6931',
        '6932',
        '6933',
        '6934',
        '6935',
        '6936',
        '6937',
        '6938',
        '6939',
        '6940',
        '6941',
        '6942',
        '6943',
        '6944',
        '6945',
        '6946',
        '6947',
        '6948',
        '6949',
        '6950',
        '6951',
        '6952',
        '6953',
        '6954',
        '6955',
        '6956',
        '6957',
        '6958',
        '6959',
        '6960',
        '6961',
        '6962',
        '6963',
        '6964',
        '6965',
        '6966',
        '6967',
        '6968',
        '6969',
        '6970',
        '6971',
        '6972',
        '6973',
        '6974',
        '6975',
        '6976',
        '6977',
        '6978',
        '6979',
        '6980',
        '6981',
        '6982',
        '6983',
        '6984',
        '6985',
        '6986',
        '6987',
        '6988',
        '6989',
        '6990',
        '6991',
        '6992',
        '6993',
        '6994',
        '6995',
        '6996',
        '6997',
        '6998',
        '6999',
    ],
    'Erträge aus Beteiligungen': [
        '7000',
        '7001',
        '7002',
        '7003',
        '7004',
        '7005',
        '7006',
        '7007',
        '7008',
        '7009',
        '7010',
        '7011',
        '7012',
        '7013',
        '7014',
        '7015',
        '7016',
        '7017',
        '7018',
        '7019',
        '7020',
        '7021',
        '7022',
        '7023',
        '7024',
        '7025',
        '7026',
        '7027',
        '7028',
        '7029',
        '7030',
        '7031',
        '7032',
        '7033',
        '7034',
        '7035',
        '7036',
        '7037',
        '7038',
        '7039',
        '7040',
        '7041',
        '7042',
        '7043',
        '7044',
        '7045',
        '7046',
        '7047',
        '7048',
        '7049',
        '7050',
        '7051',
        '7052',
        '7053',
        '7054',
        '7055',
        '7056',
        '7057',
        '7058',
        '7059',
        '7060',
        '7061',
        '7062',
        '7063',
        '7064',
        '7065',
        '7066',
        '7067',
        '7068',
        '7069',
        '7070',
        '7071',
        '7072',
        '7073',
        '7074',
        '7075',
        '7076',
        '7077',
        '7078',
        '7079',
        '7080',
        '7081',
        '7082',
        '7083',
        '7084',
        '7085',
        '7086',
        '7087',
        '7088',
        '7089',
        '7090',
        '7091',
        '7092',
        '7093',
        '7094',
        '7095',
        '7096',
        '7097',
        '7098',
        '7099',
    ],
    'sonstige Zinsen und ähnliche Erträge': [
        '7100',
        '7101',
        '7102',
        '7103',
        '7104',
        '7105',
        '7106',
        '7107',
        '7108',
        '7109',
        '7110',
        '7111',
        '7112',
        '7113',
        '7114',
        '7115',
        '7116',
        '7117',
        '7118',
        '7119',
        '7120',
        '7121',
        '7122',
        '7123',
        '7124',
        '7125',
        '7126',
        '7127',
        '7128',
        '7129',
        '7130',
        '7131',
        '7132',
        '7133',
        '7134',
        '7135',
        '7136',
        '7137',
        '7138',
        '7139',
        '7140',
        '7141',
        '7142',
        '7143',
        '7144',
        '7145',
        '7146',
        '7147',
        '7148',
        '7149',
        '7150',
        '7151',
        '7152',
        '7153',
        '7154',
        '7155',
        '7156',
        '7157',
        '7158',
        '7159',
        '7160',
        '7161',
        '7162',
        '7163',
        '7164',
        '7165',
        '7166',
        '7167',
        '7168',
        '7169',
        '7170',
        '7171',
        '7172',
        '7173',
        '7174',
        '7175',
        '7176',
        '7177',
        '7178',
        '7179',
        '7180',
        '7181',
        '7182',
        '7183',
        '7184',
        '7185',
        '7186',
        '7187',
        '7188',
        '7189',
        '7190',
        '7191',
        '7192',
        '7193',
        '7194',
        '7195',
        '7196',
        '7197',
        '7198',
        '7199',
        '7200',
        '7201',
        '7202',
        '7203',
        '7204',
        '7205',
        '7206',
        '7207',
        '7208',
        '7209',
        '7210',
        '7211',
        '7212',
        '7213',
        '7214',
        '7215',
        '7216',
        '7217',
        '7218',
        '7219',
        '7220',
        '7221',
        '7222',
        '7223',
        '7224',
        '7225',
        '7226',
        '7227',
        '7228',
        '7229',
        '7230',
        '7231',
        '7232',
        '7233',
        '7234',
        '7235',
        '7236',
        '7237',
        '7238',
        '7239',
        '7240',
        '7241',
        '7242',
        '7243',
        '7244',
        '7245',
        '7246',
        '7247',
        '7248',
        '7249',
        '7250',
        '7251',
        '7252',
        '7253',
        '7254',
        '7255',
        '7256',
        '7257',
        '7258',
        '7259',
        '7260',
        '7261',
        '7262',
        '7263',
        '7264',
        '7265',
        '7266',
        '7267',
        '7268',
        '7269',
        '7270',
        '7271',
        '7272',
        '7273',
        '7274',
        '7275',
        '7276',
        '7277',
        '7278',
        '7279',
        '7280',
        '7281',
        '7282',
        '7283',
        '7284',
        '7285',
        '7286',
        '7287',
        '7288',
        '7289',
        '7290',
        '7291',
        '7292',
        '7293',
        '7294',
        '7295',
        '7296',
        '7297',
        '7298',
        '7299',
    ],
    'Zinsen und ähnliche Aufwendungen': [
        '7300',
        '7301',
        '7302',
        '7303',
        '7304',
        '7305',
        '7306',
        '7307',
        '7308',
        '7309',
        '7310',
        '7311',
        '7312',
        '7313',
        '7314',
        '7315',
        '7316',
        '7317',
        '7318',
        '7319',
        '7320',
        '7321',
        '7322',
        '7323',
        '7324',
        '7325',
        '7326',
        '7327',
        '7328',
        '7329',
        '7330',
        '7331',
        '7332',
        '7333',
        '7334',
        '7335',
        '7336',
        '7337',
        '7338',
        '7339',
        '7340',
        '7341',
        '7342',
        '7343',
        '7344',
        '7345',
        '7346',
        '7347',
        '7348',
        '7349',
        '7350',
        '7351',
        '7352',
        '7353',
        '7354',
        '7355',
        '7356',
        '7357',
        '7358',
        '7359',
        '7360',
        '7361',
        '7362',
        '7363',
        '7364',
        '7365',
        '7366',
        '7367',
        '7368',
        '7369',
        '7370',
        '7371',
        '7372',
        '7373',
        '7374',
        '7375',
        '7376',
        '7377',
        '7378',
        '7379',
        '7380',
        '7381',
        '7382',
        '7383',
        '7384',
        '7385',
        '7386',
        '7387',
        '7388',
        '7389',
        '7390',
        '7391',
        '7392',
        '7393',
        '7394',
        '7395',
        '7396',
        '7397',
        '7398',
        '7399',
        '7400',
        '7401',
        '7402',
        '7403',
        '7404',
        '7405',
        '7406',
        '7407',
        '7408',
        '7409',
        '7410',
        '7411',
        '7412',
        '7413',
        '7414',
        '7415',
        '7416',
        '7417',
        '7418',
        '7419',
        '7420',
        '7421',
        '7422',
        '7423',
        '7424',
        '7425',
        '7426',
        '7427',
        '7428',
        '7429',
        '7430',
        '7431',
        '7432',
        '7433',
        '7434',
        '7435',
        '7436',
        '7437',
        '7438',
        '7439',
        '7440',
        '7441',
        '7442',
        '7443',
        '7444',
        '7445',
        '7446',
        '7447',
        '7448',
        '7449',
        '7450',
        '7451',
        '7452',
        '7453',
        '7454',
        '7455',
        '7456',
        '7457',
        '7458',
        '7459',
        '7460',
        '7461',
        '7462',
        '7463',
        '7464',
        '7465',
        '7466',
        '7467',
        '7468',
        '7469',
        '7470',
        '7471',
        '7472',
        '7473',
        '7474',
        '7475',
        '7476',
        '7477',
        '7478',
        '7479',
        '7480',
        '7481',
        '7482',
        '7483',
        '7484',
        '7485',
        '7486',
        '7487',
        '7488',
        '7489',
        '7490',
        '7491',
        '7492',
        '7493',
        '7494',
        '7495',
        '7496',
        '7497',
        '7498',
        '7499',
        '7500',
        '7501',
        '7502',
        '7503',
        '7504',
        '7505',
        '7506',
        '7507',
        '7508',
        '7509',
        '7510',
        '7511',
        '7512',
        '7513',
        '7514',
        '7515',
        '7516',
        '7517',
        '7518',
        '7519',
        '7520',
        '7521',
        '7522',
        '7523',
        '7524',
        '7525',
        '7526',
        '7527',
        '7528',
        '7529',
        '7530',
        '7531',
        '7532',
        '7533',
        '7534',
        '7535',
        '7536',
        '7537',
        '7538',
        '7539',
        '7540',
        '7541',
        '7542',
        '7543',
        '7544',
        '7545',
        '7546',
        '7547',
        '7548',
        '7549',
        '7550',
        '7551',
        '7552',
        '7553',
        '7554',
        '7555',
        '7556',
        '7557',
        '7558',
        '7559',
        '7560',
        '7561',
        '7562',
        '7563',
        '7564',
        '7565',
        '7566',
        '7567',
        '7568',
        '7569',
        '7570',
        '7571',
        '7572',
        '7573',
        '7574',
        '7575',
        '7576',
        '7577',
        '7578',
        '7579',
        '7580',
        '7581',
        '7582',
        '7583',
        '7584',
        '7585',
        '7586',
        '7587',
        '7588',
        '7589',
        '7590',
        '7591',
        '7592',
        '7593',
        '7594',
        '7595',
        '7596',
        '7597',
        '7598',
        '7599',
    ],
    'Steuern vom Einkommen und vom Ertrag': [
        '7600',
        '7601',
        '7602',
        '7603',
        '7604',
        '7605',
        '7606',
        '7607',
        '7608',
        '7609',
        '7610',
        '7611',
        '7612',
        '7613',
        '7614',
        '7615',
        '7616',
        '7617',
        '7618',
        '7619',
        '7620',
        '7621',
        '7622',
        '7623',
        '7624',
        '7625',
        '7626',
        '7627',
        '7628',
        '7629',
        '7630',
        '7631',
        '7632',
        '7633',
        '7634',
        '7635',
        '7636',
        '7637',
        '7638',
        '7639',
        '7640',
        '7641',
        '7642',
        '7643',
        '7644',
        '7645',
        '7646',
        '7647',
        '7648',
        '7649',
    ],
    'sonstige Steuern': [
        '7650',
        '7651',
        '7652',
        '7653',
        '7654',
        '7655',
        '7656',
        '7657',
        '7658',
        '7659',
        '7660',
        '7661',
        '7662',
        '7663',
        '7664',
        '7665',
        '7666',
        '7667',
        '7668',
        '7669',
        '7670',
        '7671',
        '7672',
        '7673',
        '7674',
        '7675',
        '7676',
        '7677',
        '7678',
        '7679',
        '7680',
        '7681',
        '7682',
        '7683',
        '7684',
        '7685',
        '7686',
        '7687',
        '7688',
        '7689',
        '7690',
        '7691',
        '7692',
        '7693',
        '7694',
        '7695',
        '7696',
        '7697',
        '7698',
        '7699',
    ],
    'Gewinnvortrag aus dem Vorjahr': [
        '7700',
        '7701',
        '7702',
        '7703',
        '7704',
        '7705',
        '7706',
        '7707',
        '7708',
        '7709',
        '7710',
        '7711',
        '7712',
        '7713',
        '7714',
        '7715',
        '7716',
        '7717',
        '7718',
        '7719',
        '7720',
        '7721',
        '7722',
        '7723',
        '7724',
        '7725',
        '7726',
        '7727',
        '7728',
        '7729',
        '7730',
        '7731',
        '7732',
        '7733',
        '7734',
    ],
    'Entnahmen aus Gewinnrücklagen': [
        '7735',
        '7736',
        '7737',
        '7738',
        '7739',
        '7740',
        '7741',
        '7742',
        '7743',
        '7744',
        '7745',
        '7746',
        '7747',
        '7748',
        '7749',
        '7750',
        '7751',
        '7752',
        '7753',
        '7754',
        '7755',
        '7756',
        '7757',
        '7758',
        '7759',
        '7760',
        '7761',
        '7762',
        '7763',
        '7764',
        '7765',
        '7766',
        '7767',
        '7768',
        '7769',
        '7770',
        '7771',
        '7772',
        '7773',
        '7774',
        '7775',
        '7776',
        '7777',
        '7778',
        '7779',
        '7780',
        '7781',
        '7782',
        '7783',
        '7784',
        '7785',
        '7786',
        '7787',
        '7788',
        '7789',
        '7790',
        '7791',
        '7792',
        '7793',
        '7794',
        '7795',
        '7796',
        '7797',
        '7798',
        '7799',
        '7800',
        '7801',
        '7802',
        '7803',
        '7804',
        '7805',
        '7806',
        '7807',
        '7808',
        '7809',
        '7810',
        '7811',
        '7812',
        '7813',
        '7814',
        '7815',
        '7816',
        '7817',
        '7818',
        '7819',
        '7820',
        '7821',
        '7822',
        '7823',
        '7824',
        '7825',
        '7826',
        '7827',
        '7828',
        '7829',
        '7830',
        '7831',
        '7832',
        '7833',
        '7834',
        '7835',
        '7836',
        '7837',
        '7838',
        '7839',
        '7840',
        '7841',
        '7842',
        '7843',
        '7844',
        '7845',
        '7846',
        '7847',
        '7848',
        '7849',
        '7850',
        '7851',
        '7852',
        '7853',
        '7854',
        '7855',
        '7856',
        '7857',
        '7858',
        '7859',
        '7860',
        '7861',
        '7862',
        '7863',
        '7864',
        '7865',
        '7866',
        '7867',
        '7868',
        '7869',
        '7870',
        '7871',
        '7872',
        '7873',
        '7874',
        '7875',
        '7876',
        '7877',
        '7878',
        '7879',
        '7880',
        '7881',
        '7882',
        '7883',
        '7884',
        '7885',
        '7886',
        '7887',
        '7888',
        '7889',
        '7890',
        '7891',
        '7892',
        '7893',
        '7894',
        '7895',
        '7896',
        '7897',
        '7898',
        '7899',
        '7900',
    ],

    // ─── HGB § 266 / § 268 / § 285 davon-Posten (Disclosure-only sub-items) ───────────────
    // Keys follow the convention `<parent_fli_name> <davon_spec_name>` set in the seed's
    // templates.ts item() helper. The frontend AccountMappingFormHelper matches `item.name`
    // against these keys to auto-assign SKR04 accounts to the davon-item.
    // Account ranges sourced from DATEV Postenstruktur "Kapitalgesellschaft groß SKR04"
    // (export S50040000232). The davon-accounts are SUBSETS of the parent FLI's accounts —
    // they are auto-mapped to BOTH places (parent + davon), reflecting that davon is a
    // disclosure subset, not an exclusive partition.

    // A.III.6 sonstige Ausleihungen → davon an Gesellschafter
    'hgb_financial_other_loans davon-an-gesellschafter': ['960-963'],

    // B.II.1 Forderungen aus Lieferungen und Leistungen → davon mit Restlaufzeit > 1 Jahr
    'hgb_trade_receivables davon-rlz-gt-1-year': ['1225-1229'],

    // B.II.2 Forderungen gegen verbundene Unternehmen → davon RLZ > 1 Jahr
    'hgb_receivables_affiliated davon-rlz-gt-1-year': ['1265'],

    // B.II.3 Forderungen gegen Beteiligungs-Unternehmen → davon RLZ > 1 Jahr
    'hgb_receivables_participations davon-rlz-gt-1-year': ['1285'],

    // B.II.4 sonstige Vermögensgegenstände → davon Gesellschafter, davon RLZ > 1 Jahr
    'hgb_other_current_assets davon-gegen-gesellschafter': ['1307-1309'],
    'hgb_other_current_assets davon-rlz-gt-1-year': ['1305-1306'],

    // C. Rechnungsabgrenzungsposten → davon Disagio
    'hgb_prepaid_expenses davon-disagio': ['1940', '1941', '1942', '1943', '1944', '1945', '1946', '1947', '1948', '1949'],

    // Passiva C.2 Verbindlichkeiten gegenüber Kreditinstituten → davon RLZ ≤ 1 J / > 1 J
    'hgb_bank_liabilities davon-rlz-le-1-year': ['1700-1899'],
    'hgb_bank_liabilities davon-rlz-gt-1-year': ['3160-3179'],

    // Passiva C.3 erhaltene Anzahlungen → davon RLZ ≤ 1 J / > 1 J
    'hgb_advance_payments_received davon-rlz-le-1-year': ['3250-3283'],
    'hgb_advance_payments_received davon-rlz-gt-1-year': ['3284-3299'],

    // Passiva C.4 Verbindlichkeiten aus Lieferungen und Leistungen → davon RLZ ≤ 1 J / > 1 J
    'hgb_trade_payables davon-rlz-le-1-year': ['3300-3336'],
    'hgb_trade_payables davon-rlz-gt-1-year': ['3337-3339'],

    // Passiva C.6 Verbindlichkeiten gegenüber verbundenen Unternehmen → davon RLZ ≤ 1 J / > 1 J
    'hgb_payables_affiliated davon-rlz-le-1-year': ['1260-1264'],
    'hgb_payables_affiliated davon-rlz-gt-1-year': ['1265'],

    // Passiva C.8 sonstige Verbindlichkeiten → 5 davon-Disclosures (§ 268 + § 285)
    'hgb_other_liabilities davon-gegenueber-gesellschaftern': ['1250-1257'],
    'hgb_other_liabilities davon-aus-steuern': ['1434'],
    'hgb_other_liabilities davon-im-rahmen-der-sozialen-sicherheit': ['3740-3759'],
    'hgb_other_liabilities davon-rlz-le-1-year': ['1200-1224'],
    'hgb_other_liabilities davon-rlz-gt-1-year': ['1225-1229'],

    // GuV § 275(2) 6.b Soziale Abgaben → davon für Altersversorgung
    'hgb_personnel_social davon-fuer-altersversorgung': ['6140-6159'],

    // GuV § 275(2) 9 Erträge aus Beteiligungen → davon aus verbundenen Unternehmen
    'hgb_investment_income davon-aus-verbundenen-unternehmen': ['7004'],

    // GuV § 275(2) 11 Sonstige Zinsen → davon aus verbundenen Unternehmen
    'hgb_other_interest_income davon-aus-verbundenen-unternehmen': ['7104'],

    // GuV § 275(2) 13 Zinsen und ähnliche Aufwendungen → davon an verbundene Unternehmen
    'hgb_interest_expenses davon-an-verbundene-unternehmen': ['7309'],
};
